import styled from 'styled-components';
import React, { useEffect, useState } from 'react';
import interact from 'interactjs';
import { ChevronLeftIcon, ChevronRightIcon } from './Icons';

const PortRotationContainer = styled.div`
  background-color: #434e64;
  border-radius: 50%;
  margin-right: 8px;
`;

export function PortRotation({
  direction,
  onPress,
}: {
  direction: 'left' | 'right';
  onPress: (e: React.MouseEvent) => void;
}) {
  const [ref, setRef] = useState<HTMLDivElement | null>(null);

  /**
   * When PortRotation button is used inside react-calendar-timeline, the interact handler
   * in there will take precedence over the regular onPress method on the styled-component here,
   * causing the parent's handler to be called before this child.
   * To fix this, the onPress handler is implemented using the same library to have it play nice.
   */
  useEffect(() => {
    if (ref) {
      const handler = (e: React.MouseEvent) => {
        onPress(e);
        e.stopPropagation();
      };

      interact(ref).on('tap', handler);
      return () => {
        interact(ref).off('tap', handler);
      };
    }
  }, [ref, onPress]);

  return (
    <PortRotationContainer ref={(el) => setRef(el)}>
      {direction === 'left' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
    </PortRotationContainer>
  );
}
